export const MODAL = 'Modal';
export const TOAST = 'Toast';
